module.exports = __webpack_public_path__ + "img/paypal.a5df240f.svg";